<template>
  <v-app id="inspire">
    <v-navigation-drawer v-model="drawer" temporary app>
      <template v-slot:prepend>
        <v-list-item class="px-2">
          <v-list-item-avatar>
            <img :src="require('@/assets/usuario.png')" />
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title>{{usuario}}</v-list-item-title>
            <v-list-item-subtitle>{{correo}}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </template>
      <v-divider></v-divider>
      <v-list>
        <v-list-item v-for="item in items" :key="item.title" :to="item.action">
          <v-list-item-icon>
            <v-icon color="primary"> {{ item.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <v-divider></v-divider>
      <v-list-item @click="dialog = true">
        <v-list-item-icon>
          <v-icon color="primary">mdi-logout</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>Cerrar Sesión</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-switch v-model="$vuetify.theme.dark" inset label="Modo Escuro" persistent-hint></v-switch>
      </v-list-item>
    </v-navigation-drawer>

    <v-app-bar app color="primary">
      <v-app-bar-nav-icon class="white--text" @click="drawer = !drawer"></v-app-bar-nav-icon>

      <v-toolbar-title class="white--text">{{ message }}</v-toolbar-title>

      <v-spacer></v-spacer>

      <v-btn icon class="white--text" @click="dialog_help = true">
        <v-icon>mdi-help-circle</v-icon>
      </v-btn>
    </v-app-bar>

    <v-main>
      <router-view></router-view>
    </v-main>
    <v-footer app inset="true">
      <v-col class="lighten-2 py-0 text-center" cols="12">
        <span class="px-4">&copy; {{ new Date().getFullYear() }} - Desarrollado por <a href="sdib.com.mx"
            target="_blank">SDIB</a></span>
      </v-col>
    </v-footer>
    <!-- MODAL DE CERRAR SESION -->
    <v-dialog v-model="dialog" max-width="400px">
      <v-card>
        <v-card-title class="text-h5 text-center">¿Estas seguro de cerrar sesión?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialog = false">Cancelar</v-btn>
          <v-btn color="blue darken-1" text @click="cerrarSesion">Cerrar Sesión</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- MODAL PARA VISULIZAR CONTACRTO-->
    <v-dialog v-model="dialog_contrato" persistent width="1200px">
      <v-card>
        <v-card-title>
          <span class="text-h5">Terminos y Condiciones</span>
        </v-card-title>
        <v-card-text>
          <pdf style="display: none;" :src="url" @num-pages="pageCount = new Array($event)" />
          <pdf v-for="(page, index) in pageCount" :key="index" :src="url" :page="index + 1" />
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="aceptarContrato()">
            Aceptar Terminos
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--DIALOG DE AYUDA  -->
    <v-dialog v-model="dialog_help" max-width="450">
      <v-card>
        <v-card-title class="text-h5 text-center">
          Reporte de problemas en sistema
        </v-card-title>
        <v-card-text>
          Telefono/whatsapp Soporte:
          <br />
          <a href="https://wa.me/524773576653" target="_blank">
            +52477-357-66-53
          </a>
          <br />
          Horario de Atención:
          <br />
          <b> 9:00 AM - 7:00 PM</b>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="dialog_help = false">
            De Acuerdo
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import service from "@/core/Servicio.js";
import pdf from "vue-pdf";
export default {
    components: {
    pdf
  },
  data() {
    return {
      message: "Luthue Digital Cliente",
      usuario: "",
      correo: "",
      dialog:false,
      dialog_help:false,
      pageCount: [],
      url: process.env+"/TERMINOS%20Y%20CONDICIONES.pdf",
      dialog_contrato:false,
      drawer: null,
      items: [
        { title: "Envios", icon: "mdi-cube-send", action: "envios" },  
        { title: "Información", icon: "mdi-account-settings-outline", action: "informacion" },    
        { title: "Nuevo Envio", icon: "mdi-email", action: "nuevo" },    
      ],
    };  
  },
  mounted() {
    this.initialize();
  },
  methods: {
     initialize() {
      if (localStorage.getItem("id") == null) {
        this.$router.push("/");
      }else{
        this.usuario = localStorage.getItem("nombre");
        this.correo = localStorage.getItem("correo");
        //Validamos que ya haya leido el contrato
        if(localStorage.getItem("contrato") == 0){
          this.dialog_contrato = true;
        }
      }
    },
    cerrarSesion(){
      localStorage.removeItem("id");
      localStorage.removeItem("nombre");
      localStorage.removeItem("correo");
      localStorage.removeItem("contrato");
      this.$router.push("/");
    },
    aceptarContrato(){
      let params = {
          cliente_id: localStorage.getItem("id"),
        };
        service
          .aceptar_contrato(params)
          .then((response) => {
            this.loader = false;
            if (response.data.response_flag == 1) {
              console.log("Hola");
              this.dialog_contrato = false;
              localStorage.setItem("contrato",1);
            }
          })
          .catch(() => {
           console.log("Error");
          });
    }
  },
};
</script>
